import { GRID_CELL_HEIGHT, GRID_CELL_WIDTH } from '@/config/grid.ts';
import type { GridCoordinates, PxCoordinates, PxDelta } from '@/types/grid.ts';

export function applyDeltaPX({ x, y }: PxCoordinates, deltaPx: PxDelta): PxCoordinates {
  return {
    x: x + deltaPx.x,
    y: y + deltaPx.y,
  };
}

export function gridToPx(
  { col, row }: GridCoordinates,
  tileWidth: number = GRID_CELL_WIDTH,
  tileHeight: number = GRID_CELL_HEIGHT,
): PxCoordinates {
  return {
    x: col * tileWidth,
    y: row * tileHeight,
  };
}

export function pxToGrid(
  { x, y }: PxCoordinates,
  tileWidth: number = GRID_CELL_WIDTH,
  tileHeight: number = GRID_CELL_HEIGHT,
): GridCoordinates {
  return {
    col: Math.max(0, Math.floor(x / tileWidth)),
    row: Math.max(0, Math.floor(y / tileHeight)),
  };
}
